import { tuple } from '../_util/type';
const ColumnFixedPlacements = tuple('left', 'right');
// eslint-disable-next-line import/prefer-default-export
export { PaginationConfig } from '../pagination';
